module.exports = __webpack_public_path__ + "img/1559374480.f7b2c764.jpg";